// extracted by mini-css-extract-plugin
export default {"todoApp":"App_todoApp__nrMll","topPanel":"App_topPanel__+yTLz"};